import '../js/slider-script.js';
import '../js/form-script.js';